import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import StandartButton from "components/atoms/StandartButton";
import SwalAlertComp from "components/SwalAlert";

import {
    getTrackerSettings,
    getTrackerSettingsAll,
    putTrackerSettings,
} from "../../redux/slices/trackerSettings/trackerSettings.asyncActions";

const TrackerSettings = ({ id, language }) => {
    const dispatch = useDispatch();
    const { availableCodes, trackerCodes, isLoading } = useSelector(
        (state) => state.trackerSettings,
    );
    const [selectedCodes, setSelectedCodes] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        dispatch(getTrackerSettingsAll());
        if (id) {
            dispatch(getTrackerSettings({ id }));
        }
    }, [dispatch, id]);

    useEffect(() => {
        setSelectedCodes(trackerCodes);
    }, [trackerCodes]);

    const handleCheckboxChange = (code) => {
        setSelectedCodes((prevSelected) =>
            prevSelected.includes(code)
                ? prevSelected.filter((item) => item !== code)
                : [...prevSelected, code],
        );
    };

    const handleUpdate = () => {
        setIsUpdating(true);
        dispatch(
            putTrackerSettings({
                id,
                selectedCodes,
            }),
        )
            .unwrap()
            .then((response) => {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.success ?? "Success",
                    message: response.message,
                    icon: "success",
                    timer: 3000,
                });
            })
            .catch((err) => {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.error ?? "Error",
                    message: err.message,
                    icon: "error",
                    timer: 3000,
                });
            })
            .finally(() => {
                setIsUpdating(false);
            });
    };

    return (
        <Box sx={{ position: "relative" }}>
            <div className="trackerSettingsSection mt-4">
                <h2>Click IDs: Key Identifiers for Conversion Tracking</h2>
                <p className="warningText">
                    Click IDs are unique identifiers appended to URLs by
                    advertising platforms to track user interactions and
                    optimize conversions. Platforms like Facebook, TikTok, and
                    Google use these IDs to understand which ads users engaged
                    with and what actions they performed. For example, fbcl
                    (Facebook), ttcl (TikTok), and gecl (Google) provide
                    critical data for accurately measuring campaign performance
                    and tracking user journeys. These identifiers help determine
                    which sources drive conversions and engagements.
                </p>

                {!isLoading && !!availableCodes && (
                    <div className="checkboxList">
                        {availableCodes.map((item) => (
                            <div key={item.code} className="form-check mt-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkbox-${item.code}`}
                                    checked={selectedCodes.includes(item.code)}
                                    onChange={() =>
                                        handleCheckboxChange(item.code)
                                    }
                                    disabled={isUpdating}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`checkbox-${item.code}`}
                                >
                                    {item.name}
                                </label>
                            </div>
                        ))}
                    </div>
                )}

                <Box display="flex" justifyContent="flex-end" marginTop={3}>
                    <StandartButton
                        variant="contained"
                        wrapperSx={{ width: "fit-content" }}
                        onClick={handleUpdate}
                        isLoading={isUpdating}
                    >
                        Update Settings
                    </StandartButton>
                </Box>
            </div>
        </Box>
    );
};

export default TrackerSettings;
